module.exports = __webpack_public_path__ + "static/img/icon.795d691.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zhetian/icon.png
// module id = bk85
// module chunks = 5